var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.75C9.75 17.75 0.75 11.25 0.75 5.75C0.75 2.95 2.95 0.75 5.75 0.75C7.55 0.75 8.95 1.75 9.75 3.05C10.55 1.75 11.95 0.75 13.75 0.75C16.55 0.75 18.75 2.95 18.75 5.75C18.75 11.25 9.75 17.75 9.75 17.75Z",
    stroke: "#151515",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardsMenuIcon);
export default __webpack_public_path__ + "static/media/boards-menu-icon.c6f65c58995195c9aaf7944a8515ae04.svg";
export { ForwardRef as ReactComponent };